<template>
  <v-flex xs12 mb-3>
    <h5 class="grey--text text--darken-4 ml-2">
      <v-icon large class="mr-1 teal--text">{{ icon }}</v-icon>
      {{ title }}
    </h5>
  </v-flex>
</template>

<script>
/**
 * @vuese
 * Sformatowany nagłówek listy
 * @group Helpers
 */
export default {
  props: {
    // ikona
    icon: { type: String, default: 'event' },
    // tekst nagłówka
    title: { type: String }
  }
};
</script>
